import { lazyModulePage } from '@/soluqr/tiers/lazyModulePage';

export const customersRouteElements = [
  {
    segment: 'customers',
    element: lazyModulePage('customers', () => import('@/soluqr/modules/customers/screens/CustomersPage')),
  },
];
